// NoMatch.tsx
import { Link, useLocation } from "react-router-dom";
import { BiErrorCircle } from "react-icons/bi";

const NoMatch = () => {
  const location = useLocation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 px-4">
      <div className="text-center">
        <BiErrorCircle className="w-24 h-24 text-red-500 mx-auto mb-4" />
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-2">Page non trouvée</p>
        <p className="text-gray-500 mb-6">
          Désolé, la page "{location.pathname}" n'existe pas ou n'est plus
          disponible.
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors"
        >
          Retour à l'accueil
        </Link>
      </div>
    </div>
  );
};

export default NoMatch;
